import gql from "graphql-tag";

export const LAST_ASSESSMENT_WITH_COACH_QUERY = gql`
  query previousCheckinsQuery($userId: ID!, $encodedUserId: ID, $orderBy: String, $assessmentDate_Isnull: Boolean) {
    userCheckIns(
      userId: $encodedUserId
      type: "COACHING"
      orderBy: $orderBy
      assessmentDate_Isnull: $assessmentDate_Isnull
    ) {
      edges {
        node {
          id
          requiredDate
          assessmentDate
          type
        }
      }
    }
    activeSubscription(userId: $userId) {
      id
      startDate
      coach {
        id
        firstName
        lastName
        userProfile {
          id
          assessmentBookingLink
        }
      }
    }
  }
`;
